import { render, staticRenderFns } from "./PurchaseRequisitionTable.vue?vue&type=template&id=5790906d&scoped=true&"
import script from "./PurchaseRequisitionTable.vue?vue&type=script&lang=ts&"
export * from "./PurchaseRequisitionTable.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseRequisitionTable.vue?vue&type=style&index=0&id=5790906d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5790906d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VDataTable,VDivider,VSpacer})
